import { useQuery } from '@apollo/client';
import useViewer, { viewerQuery } from ':src/hooks/useViewer';
import { graphql, ResultOf } from ':src/graphql';

type ViewerQueryQuery = ResultOf<typeof viewerQuery>;

export type ProgramType = Pick<
  ViewerQueryQuery['viewer']['organizationPrograms'][number],
  'id' | 'name'
>;

export const organizationProgramsWithDetailsQuery = graphql(`
  query OrganizationProgramsWithDetailsQuery {
    viewer {
      id
      organizationPrograms {
        id
        name
        introCallPreferenceId
        requiresNotesInReports
        organizationAdmins {
          id
          fullName
        }
        organizationUsers {
          id
          user {
            id
            firstName
            lastName
            mediumAvatar
          }
        }
      }
    }
  }
`);

export function usePrograms() {
  const { viewer } = useViewer();
  return { programs: viewer.organizationPrograms };
}

type OrganizationProgramsWithDetailsQueryQuery = ResultOf<
  typeof organizationProgramsWithDetailsQuery
>;
export type ProgramWithDetailsType = NonNullable<
  OrganizationProgramsWithDetailsQueryQuery['viewer']['organizationPrograms']
>[number];

export function useProgramsWithDetails() {
  const { data, loading } = useQuery(organizationProgramsWithDetailsQuery);
  const programs = data?.viewer.organizationPrograms ?? [];

  return { programs, loading };
}
